import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import ButtonPolicy from "../Permission/ButtonPolicy";
import ItemTypes from "src/util/utility_enums";
import {
  Createitem,
  UpdateItem,
  prepareItemData,
  updateItemData,
} from "src/apis/item";
import { useAlertContext } from "src/hooks/use-alert";

const ItemUseForm = ({
  type,
  handleClose,
  assetData,
  setItems,
  handleEditItemClose,
  editItem,
}) => {
  const alert = useAlertContext();

  const [isItemCreated, setIsItemCreated] = useState(false);
  const [advice, setAdvice] = useState("");

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm(
    // useForm default values based on the type of form
    type === "Create New Item"
      ? {
          defaultValues: {
            serialNumber: "",
            itemType: "",
            thresholdCritical: "",
            thresholdHigh: "",
            thresholdMedium: "",
            thresholdLow: "",
            active: true,
            alarm: false,
            itemDescription: "",
          },
        }
      : {
          defaultValues: {
            serialNumber: editItem.serialNumber || "",
            itemType: editItem.itemType.name || "",
            thresholdCritical: editItem.thresholdCritical || "",
            thresholdHigh: editItem.thresholdHigh || "",
            thresholdMedium: editItem.thresholdMedium || "",
            thresholdLow: editItem.thresholdLow || "",
            active: editItem.active || true,
            alarm: editItem.alarm || false,
            itemDescription: editItem.itemDescription || "",
          },
        }
  );

  // styling for dropdown menu of Mui select
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 700,
        width: 250,
        marginTop: 10,
      },
    },
  };

  const onSubmit = (data) => {
    const itemTypeId = ItemTypes.find((item) => item.name === data.itemType);
    data.itemType = itemTypeId;
    if (type === "Create New Item") {
      const newData = { ...data, assetData };
      // body object to create new item
      const body = prepareItemData(newData);
      createItem(body);
    } else if (type === "Edit Item") {
      // body object to update item
      const body = updateItemData(data);
      body.id = editItem.id;
      updateItem(body);
    }
  };

  // API calls start
  const createItem = async (item) => {
    try {
      const res = await Createitem(item);
      if (res.success === true) {
        reset();
        setIsItemCreated(true);
        // updated items list
        setItems((prevItems) => [...prevItems, item]);
        setAdvice("New Item created successfully");
      }
      if (res.success === false) {
        alert.setError((prev) => [
          ...prev,
          {
            status: true,
            message: "Serial number" + res.errors.serial_number,
          },
        ]);
      }
    } catch (error) {
      console.error("Error creating item:", error);
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          messages: "Error creating item",
          index: prev.length,
        },
      ]);
    }
  };

  const updateItem = async (item) => {
    try {
      const res = await UpdateItem(item);
      if (res.success === true) {
        reset();
        setIsItemCreated(true);
        // updated items list
        setItems((prevItems) =>
          prevItems.map((eachItem) =>
            eachItem.id === item.id ? item : eachItem
          )
        );
        setAdvice("Item updated successfully");
      }
    } catch (error) {
      console.error("Error updating item:", error);
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          messages: "Error updating item",
          index: prev.length,
        },
      ]);
    }
  };
  // API calls end

  const handleItemDialog = () => {
    setIsItemCreated(false);
    if (type === "Create New Item") {
      handleClose();
    } else if (type === "Edit Item") {
      handleEditItemClose();
    }
  };

  return (
    <div style={{ backgroundColor: "black" }}>
      <DialogTitle
        style={{
          color: "white",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {type}
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            width: "500px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <form>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 160px)",
                gap: "15px",
                overflowY: "hidden",
              }}
            >
              <div>
                <label>serialNumber:</label>
                <Controller
                  name="serialNumber"
                  control={control}
                  rules={{
                    required: "Value cannot be empty",
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      autoFocus
                      inputProps={{
                        style: {
                          fontSize: 14,
                          height: 30,
                          padding: "0 14px",
                          fontWeight: "bold",
                          color: "white",
                          backgroundColor: "#1C1E24",
                        },
                      }}
                      value={value}
                      onChange={onChange}
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                />
              </div>
              <FormControl>
                <label>itemType:</label>
                <Controller
                  name="itemType"
                  control={control}
                  rules={{
                    required: "Value cannot be empty",
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <Select
                      sx={{
                        color: "white",
                        height: 36,
                        backgroundColor: "#1C1E24",
                        ".MuiSvgIcon-root ": {
                          fill: "white !important",
                        },
                      }}
                      value={value}
                      onChange={onChange}
                      error={!!error}
                      MenuProps={MenuProps}
                    >
                      <MenuItem>Select item type</MenuItem>
                      {ItemTypes.map((item) => (
                        <MenuItem value={item.name}>{item.name}</MenuItem>
                      ))}
                    </Select>
                  )}
                />
                {errors?.itemType && (
                  <span
                    style={{
                      fontSize: "12px",
                      padding: "5px 0px 0px 10px",
                      color: "#d32f2f",
                    }}
                  >
                    {errors.itemType.message}
                  </span>
                )}
              </FormControl>
              <div>
                <label>thresholdCritical:</label>
                <Controller
                  name="thresholdCritical"
                  control={control}
                  rules={{
                    required: "Campo obbligatorio",
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      type="number"
                      inputProps={{
                        style: {
                          fontSize: 14,
                          height: 30,
                          padding: "0 14px",
                          fontWeight: "bold",
                          color: "white",
                          backgroundColor: "#1C1E24",
                        },
                      }}
                      value={value}
                      onChange={onChange}
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                />
              </div>
              <div>
                <label>thresholdHigh:</label>
                <Controller
                  name="thresholdHigh"
                  control={control}
                  rules={{
                    required: "Campo obbligatorio",
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      type="number"
                      inputProps={{
                        style: {
                          fontSize: 14,
                          height: 30,
                          padding: "0 14px",
                          fontWeight: "bold",
                          color: "white",
                          backgroundColor: "#1C1E24",
                        },
                      }}
                      value={value}
                      onChange={onChange}
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                />
              </div>
              <div>
                <label>thresholdMedium:</label>
                <Controller
                  name="thresholdMedium"
                  control={control}
                  rules={{
                    required: "Campo obbligatorio",
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      type="number"
                      inputProps={{
                        style: {
                          fontSize: 14,
                          height: 30,
                          padding: "0 14px",
                          fontWeight: "bold",
                          color: "white",
                          backgroundColor: "#1C1E24",
                        },
                      }}
                      value={value}
                      onChange={onChange}
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                />
              </div>
              <div>
                <label>thresholdLow:</label>
                <Controller
                  name="thresholdLow"
                  control={control}
                  rules={{
                    required: "Campo obbligatorio",
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <TextField
                      type="number"
                      inputProps={{
                        style: {
                          fontSize: 14,
                          height: 30,
                          padding: "0 14px",
                          fontWeight: "bold",
                          color: "white",
                          backgroundColor: "#1C1E24",
                        },
                      }}
                      value={value}
                      onChange={onChange}
                      error={!!error}
                      helperText={error ? error.message : null}
                    />
                  )}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>active:</label>
                <Controller
                  control={control}
                  name="active"
                  defaultValue={true}
                  render={({ field: { onChange, value, ...field } }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={onChange}
                          checked={value}
                          {...field}
                        />
                      }
                    />
                  )}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label>alarm:</label>
                <Controller
                  control={control}
                  name="alarm"
                  defaultValue={false}
                  render={({ field: { onChange, value, ...field } }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={onChange}
                          checked={value}
                          {...field}
                        />
                      }
                    />
                  )}
                />
              </div>
            </div>
            <div>
              <label>itemDescription:</label>
              <Controller
                name="itemDescription"
                control={control}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <TextField
                    sx={{ width: "100%", backgroundColor: "#1C1E24" }}
                    inputProps={{
                      style: {
                        fontSize: 14,
                        fontWeight: "bold",
                        color: "white",
                      },
                    }}
                    multiline={true}
                    rows={7}
                    autoComplete="off"
                    variant="outlined"
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
            </div>
          </form>
        </div>
      </DialogContent>

      <div className="bottomPart" style={{ padding: "10px 0 10px 0" }}>
        <DialogActions>
          <Grid container>
            <Grid item xs={6} md={6}>
              <div className="cancelButton">
                <ButtonPolicy
                  onClick={
                    type === "Create New Item"
                      ? handleClose
                      : handleEditItemClose
                  }
                  variant="text"
                >
                  Cancel
                </ButtonPolicy>
              </div>
            </Grid>
            <Grid item xs={6} md={6}>
              <div className="addButton">
                <ButtonPolicy variant="text" onClick={handleSubmit(onSubmit)}>
                  submit
                </ButtonPolicy>
              </div>
            </Grid>
          </Grid>
        </DialogActions>
      </div>
      
      {/* Advice dialog box for displaying successful creation and updation of an item */}
      <Dialog open={isItemCreated} onClose={handleItemDialog}>
        <div className="modalContainer" style={{ backgroundColor: "#282b30" }}>
          <DialogContent>
            <div className="advice">{advice}</div>
          </DialogContent>
        </div>
      </Dialog>
    </div>
  );
};

export default ItemUseForm;
